import { FC, useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'shared/lib/store';
import { Place } from '../model/types';
import { Container } from './styles';
import { PlacesItem } from './placesItem';
import { selectPlaces } from '../model/selectors';
import { Game } from 'shared/lib/core';

interface PlacesNavigationProps {
	hallmap: Game | undefined;
	sendRequestToGetPlaces?: boolean;
}

export const PlacesNavigation: FC<PlacesNavigationProps> = ({ hallmap }) => {
	const places = useAppSelector(selectPlaces);
	const [selectedItem, setSelectedItem] = useState<number>(1);

	const selectPlaceHandler = (placeId: number) => {
		setSelectedItem(placeId);
		selectTablesByPlace(placeId);
	};

	const selectTablesByPlace = useCallback(
		(place: number) => {
			if (hallmap) {
				hallmap.focusOnTablesByPlace(place);
			}
		},
		[hallmap],
	);

	useEffect(() => {
		if (hallmap) {
			selectTablesByPlace(1);
		}
	}, [hallmap, selectTablesByPlace]);

	return (
		<Container>
			{places.map((place: Place) => {
				return (
					<PlacesItem
						key={place.id}
						selectPlace={selectPlaceHandler}
						placeId={place.id}
						name={place.name}
						isSelected={place.id === selectedItem}
					/>
				);
			})}
		</Container>
	);
};
